'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseScheduledTask', ['$scope', '$stateParams', 'LicenseScheduledTasks', 'Enterprise', 'LicenseCategoryCertificationStatuses', function ($scope, $stateParams, LicenseScheduledTasks, Enterprise, LicenseCategoryCertificationStatuses) {
        $scope.resetLicense();
        $scope.licenseID = $stateParams.id;
        $scope.licenseCategoryID = $stateParams.licenseCategoryID;
        $scope.scheduledTask = $stateParams.scheduledTask;
        $scope.scheduledTaskID = $stateParams.scheduledTaskID;
        $scope.criteriaCertIssueDateIsRequired = false;
        $scope.criteriaCertExpirationDateIsRequired = false;
        $scope.actionCertIssueDateReferenceDateIsRequired = false;
        $scope.actionCertExpirationDateReferenceDateIsRequired = false;
        $scope.actionCertIssueDateReferenceMonthIsRequired = false;
        $scope.actionCertExpirationDateReferenceMonthIsRequired = false;
        $scope.scheduledTaskLoading = true;

        if ($scope.scheduledTaskID) {
            LicenseScheduledTasks.getByID($scope.scheduledTaskID).then(function (scheduledTask) {
                $scope.scheduledTask = scheduledTask;

                Enterprise.get({ enterpriseID: $scope.scheduledTask.enterprise_id }).then(function (enterprise) {
                    $scope.enterprise = enterprise;

                    var timeString = $scope.scheduledTask.frequency_begin_time == null ? "12:00:00" : $scope.scheduledTask.frequency_begin_time.toString();
                    var begin_time_hours = timeString.substr(0, 2);
                    var begin_time_minutes = timeString.substr(timeString.indexOf(":") + 1, 2);
                    var begin_date_time_string = new Date(1900, 0, 1, parseInt(begin_time_hours), parseInt(begin_time_minutes)).toString();
                    var locale_date_string = new Date(begin_date_time_string).toLocaleString();
                    var frequency_begin_date = new Date(locale_date_string);

                    Date.prototype.addHours = function (h) {
                        this.setTime(this.getTime() + (h * 60 * 60 * 1000));
                        return this;
                    }

                    frequency_begin_date.addHours($scope.enterprise.server_spec.utc_to_server_hours);
                    $scope.scheduledTask.frequency_begin_date = frequency_begin_date;

                    // British English uses 24-hour time without AM/PM
                    var frequency_begin_time = frequency_begin_date.toLocaleTimeString('en-GB');
                    $scope.scheduledTask.frequency_begin_time = frequency_begin_time;

                    $scope.criteriaCertIssueDateIsRequired = (scheduledTask.certification_issue_date_comparison_type || scheduledTask.certification_issue_date_part_value || scheduledTask.certification_issue_date_part || scheduledTask.certification_issue_date_comparison_operator) ? true : false;
                    $scope.criteriaCertExpirationDateIsRequired = (scheduledTask.certification_expiration_date_comparison_type || scheduledTask.certification_expiration_date_part_value || scheduledTask.certification_expiration_date_part || scheduledTask.certification_expiration_date_comparison_operator) ? true : false;

                    if ($scope.scheduledTask.action_license_category == null) {
                        $scope.scheduledTask.action_license_category = $scope.licenseCategoryID;
                    }

                    LicenseCategoryCertificationStatuses.get({ 'license_category_id': $scope.scheduledTask.action_license_category }).then(function (certificationStatuses) {
                        $scope.license_category_certification_statuses = certificationStatuses;
                    });
                    if ($scope.scheduledTask.action_add_or_update_cert == null) {
                        $scope.scheduledTask.action_add_or_update_cert = 0;
                    }

                    if ($scope.scheduledTask.action_set_cert_issue_date == null) {
                        $scope.scheduledTask.action_set_cert_issue_date = 'i';
                    }
                    $scope.actionCertIssueDateReferenceDateIsRequired = (scheduledTask.action_set_cert_issue_date == 'r') ? true : false;
                    $scope.actionCertIssueDateReferenceMonthIsRequired = (scheduledTask.action_set_cert_issue_date == 'm') ? true : false;

                    if ($scope.scheduledTask.action_set_cert_expiration_date == null) {
                        $scope.scheduledTask.action_set_cert_expiration_date = 'i';
                    }
                    $scope.actionCertExpirationDateReferenceDateIsRequired = (scheduledTask.action_set_cert_expiration_date == 'r') ? true : false;
                    $scope.actionCertExpirationDateReferenceMonthIsRequired = (scheduledTask.action_set_cert_expiration_date == 'm') ? true : false;

                    //Set national registry option
                    if ($scope.scheduledTask.verify_national_registry == true) {
                        $scope.scheduledTask.action_data_exchange = 'verify_national_registry_certification';
                    }
                    $scope.scheduledTaskLoading = false;
                })
            })
        } else {
            $scope.scheduledTask = {};
            $scope.scheduledTask.license_ID = $scope.licenseID;
            $scope.scheduledTask.currently_active = true;
            $scope.scheduledTask.frequency_begin_date = new Date().setHours(12, 0, 0);
            $scope.scheduledTask.action_license_category = $scope.licenseCategoryID;
            LicenseCategoryCertificationStatuses.get({ 'license_category_id': $scope.licenseCategoryID }).then(function (certificationStatuses) {
                $scope.license_category_certification_statuses = certificationStatuses;
            });
            $scope.scheduledTask.action_add_or_update_cert = 0;
            $scope.scheduledTask.action_set_cert_issue_date = 'i';
            $scope.scheduledTask.action_set_cert_expiration_date = 'i';
            $scope.scheduledTask.currently_active = 0;
            $scope.scheduledTask.apply_cert_to_service_affiliation = false; //Default apply_cert to off
            $scope.scheduledTaskLoading = false;
        }
    }])
    ;